import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

function Home() {
  return (
    <div className="home-container">
      <h1>Bienvenue sur votre Calculateur de score de jeux de société</h1>
      <p>Choisissez un jeu pour commencer à compter les points</p>

      <div className="games-container">
        <Link to="/yams" className="game-button">
          Yams
        </Link>
        <Link to="/generic" className="game-button generic-button">
          Score générique
        </Link>
        {/* Boutons pour d'autres jeux à ajouter dans le futur */}
      </div>
    </div>
  );
}

export default Home;
